import { render } from "./PublicBrandHeader.vue?vue&type=template&id=046000f1&scoped=true"
import script from "./PublicBrandHeader.vue?vue&type=script&lang=js"
export * from "./PublicBrandHeader.vue?vue&type=script&lang=js"

import "./PublicBrandHeader.vue?vue&type=style&index=0&id=046000f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046000f1"]])

export default __exports__